import React, { createContext, useContext, useState } from "react";

const SequenceContext = createContext();

export const SequenceProvider = ({ children }) => {
  const [isSequenceStarted, setIsSequenceStarted] = useState(false);
  const [isSequenceCompleted, setIsSequenceCompleted] = useState(false);

  const startSequence = () => {
    setIsSequenceStarted(true);
    setIsSequenceCompleted(false); // Reset completed state
  };

  const completeSequence = () => {
    setIsSequenceCompleted(true);
    setIsSequenceStarted(false); // End the sequence
  };

  return (
    <SequenceContext.Provider
      value={{
        isSequenceStarted,
        isSequenceCompleted,
        startSequence,
        completeSequence,
      }}
    >
      {children}
    </SequenceContext.Provider>
  );
};

export const useSequence = () => {
  const context = useContext(SequenceContext);
  if (!context) {
    throw new Error("useSequence must be used within a SequenceProvider");
  }
  return context;
};
